import * as React from 'react';
import { selectSize } from 'app/area/indicator-factors/item/code-pickers/types';
import { CodeSinglePicker } from 'app/area/shared/codetable/common/code-picker/code-single-picker';
import { CodeSinglePickerProps } from 'app/area/shared/codetable/common/code-picker/types';

export const SinglePickerCreator = (props: CodeSinglePickerProps) => <CodeSinglePicker size={selectSize} {...props} />;
